/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ReceiptModel from 'cio/models/receipt';
import SubscriptionModel from 'cio/models/subscription';

interface BillingHistoryArgs {
  model: ReceiptModel[];
  subscription?: SubscriptionModel;
}

export default class BillingHistory extends Component<BillingHistoryArgs> {
  get subscription() {
    return this.args.subscription ?? null;
  }
}
